import React from 'react';
import EmployeeCalendar from './EmployeeCalendar';

const AnniversaryCalendar = ()=><EmployeeCalendar  accessor={'hireDate'} />;

export default AnniversaryCalendar;